$(document).ready(function() {
	if ($(".js-longrid-menu-new").length > 0) {
		let upperElement = $(".js-longrid-menu-new").parent(".js-tabs-wrap").prev();
		$(window).on('scroll', function() {
			if ($(this).scrollTop() >= $(".js-longrid-menu-new").position().top) {
				$(".js-longrid-menu-new").addClass("fixed");
				upperElement.css("padding-bottom", $(".js-longrid-menu-new").height() + "px");
			}
			if ($(this).scrollTop() < 
					(upperElement.position().top + upperElement.outerHeight()) - 100) {
				$(".js-longrid-menu-new").removeClass("fixed");
				upperElement.css("padding-bottom", "0");
			}
		});

		$("body").on("click", function(e) {
			if (!((e.target).closest(".js-longrid-menu-new-inner"))
					&& !((e.target).closest(".js-longrid-menu-new-sign"))) {
				$(".js-longrid-menu-new-inner").removeClass("show");
				$("body").removeClass("fixed-position-modal");
			}
		});

		$(".js-anchor").on("click", function() {
			$(".js-longrid-menu-new-inner").removeClass("show");
			$("body").removeClass("fixed-position-modal");
		});
	}

	$(".js-longrid-menu-new-sign").on("click", function() {
		$(".js-longrid-menu-new-inner").toggleClass("show");
		if ($(window).width() < 1024) {
			$("body").toggleClass("fixed-position-modal");
		}
	});

	$(".js-longrid-menu-new-close").on("click", function() {
		$(".js-longrid-menu-new-inner").removeClass("show");
		$("body").removeClass("fixed-position-modal");
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/longrid/longrid-menu-new.js